//NPM LIBRARIES
import queryString from 'query-string';
//REDUX ACTIONS AND SELECTORS
import { addPageAlert } from '../../PortalStore/Actions/PageAlertActions';

export const getCalculatedField = (calculatedFieldId, formData) => {
    let index = formData?.calcs.findIndex(element => element.id === calculatedFieldId);

    if (index !== -1) {
        const value = formData.calcs[index];
        return {value, index};
    }

    return null;
}

export const getCheckbox = (answerid, checkboxid, formData) => {
    var checkbox = {};

    var stepindex = formData.steps.findIndex(function (a) {
        return a.stepid === formData.currentstep;
    });

    if (stepindex === -1) {
        return
    }

    var answerindex = formData.steps[stepindex].answers.findIndex(function (a) {
        return a.questionid === answerid;
    });

    var checkboxindex = -1;
    if (answerindex !== -1) {
        checkboxindex = formData.steps[stepindex].answers[answerindex].checkboxvalues.findIndex(function (a) {
            return a.optionid === checkboxid;
        });
    }

    if (checkboxindex !== -1) {
        checkbox = formData.steps[stepindex].answers[answerindex].checkboxvalues[checkboxindex];
        return {checkbox, stepindex, answerindex, checkboxindex};
    }
    return {checkbox, stepindex, answerindex, checkboxindex};
}

// export const getQuestion = (questionid, stepid, formData) => {
//     var question = {};

//     var stepindex = formData.steps.findIndex(function (a) {
//         return a.stepid === stepid;
//     });

//     if (stepindex < 0) {
//         return
//     }

//     var questionindex = formData.steps[stepindex].questions.findIndex(function (a) {
//         return a.questionid === questionid;
//     });

//     if (questionindex !== -1) {
//         question = formData.steps[stepindex].questions[questionindex];
//         return { question, stepindex, questionindex };
//     }
//     return { question, stepindex, questionindex };
// }


export const getStep = (stepid, formData) => {
    var step = {};

    var stepindex = formData.steps.findIndex(function (a) {
        return a.stepid === stepid;
    });

    if (stepindex !== -1) {
        step = formData.steps[stepindex];
        return {step, stepindex};
    }
    return {step, stepindex};
}

export const validateAnswerHasValue = (questionType, answer, mandatory) => {
    let questionErrorMessage = null;

    if (!mandatory) {
        return questionErrorMessage;
    }
    
    if (mandatory && (questionType === 'checkbox' || questionType === 'declaration')) {
        if (!answer?.checkboxValues || answer.checkboxValues.length === 0) {
            questionErrorMessage = 'Please select an option';
        }

        return questionErrorMessage;
        // Check whether question is mandatory and if it is check whether it's value is null or empty
    } else if (mandatory && (answer === null || answer.value === null || answer.value === '')) {
        switch (questionType) {
            case 'googleMapAddressPicker':
                questionErrorMessage = 'Please enter a value or select an address from the map'
                break;
            case 'checkbox':
            case 'select':
            case 'radio':
            case 'conditionalDeclaration':
                questionErrorMessage = 'Please select an option'
                break;
            case 'filePicker':
                questionErrorMessage = 'Please upload a document before proceeding'
                break;
            default:
                questionErrorMessage = 'This field cannot be left blank'
        }
    } 

    return questionErrorMessage;
}

export const validateStep = (stepQuestionData) => {
    var stepErrorMessage = null;
    //Check if to ensure StepQuestion Data is no null
    if (stepQuestionData !== null && stepQuestionData !== undefined) {
        //Loop through all questions and validate each one
        for (const [key, value] of Object.entries(stepQuestionData)) {
            if (!value.errorMessage) {
                stepErrorMessage = validateAnswerHasValue(value.type, value.answer, value.mandatory);
                if (!stepErrorMessage && value.validate) {
                    stepErrorMessage = value.validate(stepQuestionData)
                }
                if (stepErrorMessage) {
                    break
                }
            } else {
                if (value.validate) {
                    stepErrorMessage = value.validate(stepQuestionData)
                }
                else {
                    stepErrorMessage = value.errorMessage;
                }
                break
            }
        }
        return stepErrorMessage
    }
}

export const validateForm = (formData, dispatch) => {
    var errmsg = null;
    var haserrmsg = null;

    if (formData.validate !== null && formData.validate !== undefined) {
        errmsg = formData.validate(formData);

        if (errmsg !== null) {
            haserrmsg = errmsg;
        }

    }
    return haserrmsg;
}
export const convertQuestionsToArray = (formData) => {
    return (
        formData.map(step => {
            const questions = Object.values(step.questions).map(question => {
                return (
                    {
                        ...question,
                        answer: {
                            ...question.answer,
                            checkboxes:  question.answer.checkboxes ? Object.values(question.answer.checkboxes) : []
                        }
                    }
                )
            })
            return (
                {
                    ...step,
                    questions: questions
                }
            );
        })
    )
}

export const processUrlParameters = (windowUrl, dispatch) => {
    let urlParameters = queryString.parse(windowUrl)
    if (urlParameters.params) {
        try {
            return JSON.parse(atob(decodeURIComponent(urlParameters.params)))
        } catch (e) {
            dispatch(addPageAlert({
                level: "error",
                title: "Unable to complete application online",
                message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
            }));
            return
        }
    }
}
/** Returns the submission summary dashboard url
 *
 * @param organisationId
 * @returns {string|string}
 */
export const getSubmissionDashboardUrl = (organisationId) => {
    return organisationId ? `/appsorg?casaorgid=${organisationId}` : `/appsind`;
}

/** Returns the organisation or individual dashboard url
 *
 * @param organisationId
 * @returns {string|string}
 */
export const getDashboardUrl = (organisationId) => {
    return organisationId ? `/dashorg?casaorgid=${organisationId}` : `/dashind`;
}

